import RelatedExperiences from "components/ExperiencePresentation/RelatedExperiences/RelatedExperiences";
import styles from "./RelatedExperiencesSection.module.scss";

export default function RelatedExperiencesSection({
  experiences,
  sideScroll = "all",
  sideScrollButtons,
  cardRowRef,
  scrollIndicator,
  scrollAfterCardsCount,
}) {
  return (
    <div className={`${styles.container}`}>
      <RelatedExperiences
        experiences={experiences}
        sideScroll={sideScroll}
        sideScrollButtons={sideScrollButtons}
        scrollIndicator={scrollIndicator}
        scrollAfterCardsCount={scrollAfterCardsCount}
        cardRowRef={cardRowRef}
      />
    </div>
  );
}
